import { INTERNAL_AGENT_PAYMENT_METHODS } from "../../shared/constants";

/**
 * @function getFilteredPaymentMethodGroups remove blacklisted key on payment method groups
 * @param {paymentMethodGroups} Object payment method groups
 * @param {isPaymentTermOneTime} Boolean define if selected payment term equals ONE_TIME
 * @returns {Object} filtered payment method groups or empty object
 */

export const filterPaymentMethodsForPaymentLink = (dataList = []) => {
  return dataList.filter(
    (row) => !INTERNAL_AGENT_PAYMENT_METHODS.includes(row.paymentMethod)
  );
};

export const getFilteredPaymentMethodGroups = ({
  paymentMethodGroups,
  isPaymentTermOneTime,
}) => {
  const blacklistedPaymentMethodGroups = isPaymentTermOneTime
    ? []
    : ["Cicilan"];

  if (!Object.keys(paymentMethodGroups).length) {
    return {};
  }

  return Object.keys(paymentMethodGroups)
    .filter((key) => !blacklistedPaymentMethodGroups.includes(key))
    .sort()
    .reduce((obj, key) => {
      obj[key] = paymentMethodGroups[key];
      return obj;
    }, {});
};

export const getSalesforceFilteredPaymentMethodGroups = ({
  paymentMethodGroups,
}) => {
  if (!Object.keys(paymentMethodGroups).length) {
    return {};
  }

  return Object.keys(paymentMethodGroups)
    .filter((key) => ["Transfer Bank", "Kartu Kredit / Kartu Debit", "Cicilan"].includes(key))
    .reduce((obj, key) => {
      obj[key] = {
        ...paymentMethodGroups[key],
        children: paymentMethodGroups[key].children.filter(
          (objKeyChild) => objKeyChild.paymentProvider === "XENDIT"
        ),
      };

      return obj;
    }, {});
};

const getBankInstallments = (dataList = []) => {
  let bankInstallments = [];

  dataList
    .filter(row => row.paymentMethod === 'INSTALLMENT' && row.isActive !== false)
    .forEach(data => {
      const bankInstallmentsData = Array.isArray(data.bankInstallments)
        ? data.bankInstallments
        : [];

      bankInstallmentsData.forEach(installment => {
        const foundIndex = bankInstallments.findIndex(installmentChild => {
          return installmentChild.displayName === installment.display && !installmentChild.tenures.includes(installment.tenure);
        });

        if (foundIndex < 0) {
          bankInstallments.push({
            paymentMethod: installment.bankName,
            paymentProvider: installment.provider,
            displayName: installment.display,
            tenures: [{
              promoId: installment.promoId,
              tenure: installment.tenure,
              feeAmount: data.feeAmount,
              feeType: data.feeType,
            }],
          });
          return;
        }

        bankInstallments[foundIndex].tenures.push({
          promoId: installment.promoId,
          tenure: installment.tenure,
          feeAmount: data.feeAmount,
          feeType: data.feeType,
        });
      });
    });

  return bankInstallments;
};

export const getPaymentMethodGroups = (dataList = []) => {
  let installmentCounter = 0;

  return dataList
    .filter(row => row.isActive !== false)
    .sort()
    .reduce((acc, row) => {
      const paymentMethodDetail = {
        paymentMethod: row.paymentMethod,
        paymentProvider: row.paymentProvider,
        children: [],
      };

      if (row.paymentMethod === 'INSTALLMENT' && installmentCounter < 1) {
        acc['Cicilan'] = {
          ...paymentMethodDetail,
          children: getBankInstallments(dataList),
        };
        installmentCounter += 1;
      } else if (row.paymentMethod.includes('_VA')) {
        if (!acc['Transfer Bank']) {
          acc['Transfer Bank'] = paymentMethodDetail;
        }
        acc['Transfer Bank'].children.push(row);
      } else if (['DANA', 'LINKAJA', 'OVO', 'GOPAY', 'RECURRING'].includes(row.paymentMethod)) {
        if (!acc['E-Wallet']) {
          acc['E-Wallet'] = paymentMethodDetail;
        }
        acc['E-Wallet'].children.push(row);
      } else if (['ALFAMART', 'INDOMARET'].includes(row.paymentMethod)) {
        if (!acc['Minimarket']) {
          acc['Minimarket'] = paymentMethodDetail;
        }
        acc['Minimarket'].children.push(row);
      } else if (['KREDIVO', 'AKULAKU', 'INDODANA'].includes(row.paymentMethod)) {
        if (!acc['Cicilan Tanpa Kartu Kredit']) {
          acc['Cicilan Tanpa Kartu Kredit'] = paymentMethodDetail;
        }
        acc['Cicilan Tanpa Kartu Kredit'].children.push(row);
      } else if (['CIMB_CLICK', 'DANAMON_IB', 'BRI_EPAY', 'BCA_KLIKPAY'].includes(row.paymentMethod)) {
        if (!acc['Online Payment']) {
          acc['Online Payment'] = paymentMethodDetail;
        }
        acc['Online Payment'].children.push(row);
      } else if (row.paymentMethod === 'QRIS') {
        if (!acc['QRIS']) {
          acc['QRIS'] = paymentMethodDetail;
        }
        acc['QRIS'].children.push(row);
      } else if (row.paymentMethod.includes('AUTODEBIT_')) {
        if (!acc['Direct Debit']) {
          acc['Direct Debit'] = paymentMethodDetail;
        }
        acc['Direct Debit'].children.push(row);
      } else if (row.paymentMethod === 'AUTODEBIT') {
        if (!acc['Autodebit']) {
          acc['Autodebit'] = paymentMethodDetail;
        }
      } else if (row.paymentMethod === 'CREDIT_CARD') {
        if (!acc['Kartu Kredit / Kartu Debit']) {
          acc['Kartu Kredit / Kartu Debit'] = paymentMethodDetail;
        }
      } else if (row.paymentMethod === 'RECURRING_MOTO') {
        if (!acc['Recurring Moto']) {
          acc['Recurring Moto'] = paymentMethodDetail;
        }
      } else if (row.paymentMethod === 'SEND_PAYMENT_LINK') {
        if (!acc['Send Payment Link']) {
          acc['Send Payment Link'] = paymentMethodDetail;
        }
      }
      return acc;
    }, {});
};
